import * as React from 'react'

import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color, backgroundColor }: IconOptions) {
  return (
    <React.Fragment>
      <path
        d='M0.5 4C0.5 2.067 2.067 0.5 4 0.5H20C21.933 0.5 23.5 2.067 23.5 4V20C23.5 21.933 21.933 23.5 20 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4Z'
        fill={backgroundColor}
        stroke={'#D5D6EA'}
      />
      <path d='M18 8L10.9289 15.0711L7.3934 11.5355' stroke={color} strokeWidth='1.5' />
    </React.Fragment>
  )
}

export const CheckboxIcon = createIcon(IconContent)
